module.exports = __webpack_public_path__ + "img/mail.6c303fc9.svg";